import React, { ComponentProps, MouseEvent, ReactNode } from 'react'
import clsx from 'clsx'
import useStyles from './styles'
import MuiButton from '@mui/material/Button'
import { useIsPhoneOnly } from 'src/config/mediaQueries'
import CircularProgress from '@mui/material/CircularProgress'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'

interface Props extends ComponentProps<typeof MuiButton> {
  className?: string
  disabled?: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  text: string | ReactNode
  loading?: boolean
  fullSize?: boolean
  phoneSize?: ComponentProps<typeof MuiButton>['size']
  additionalDebugData?: string
  defaultWidth?: boolean
}

export const Button = ({
  onClick,
  text = '',
  disabled,
  className = '',
  variant = 'filled',
  size = 'xl',
  phoneSize = 'lg',
  loading,
  fullSize = false,
  additionalDebugData,
  defaultWidth = false,
  ...restProps
}: Props) => {
  const classes = useStyles()

  const classNames = clsx(className, 'notranslate', {
    [classes.fullSize]: fullSize,
    [classes.defaultWidth]: defaultWidth,
  })
  const isPhone = useIsPhoneOnly()
  const buttonSize = isPhone ? phoneSize : size

  const loaderFallback = (
    <div className={classes.alignCenter}>
      <CircularProgress size={40} />
    </div>
  )

  return (
    <ErrorBoundary additionalDebugData={`Button - ${additionalDebugData}`} fallback={loaderFallback}>
      <MuiButton
        onClick={onClick}
        disabled={disabled || loading}
        variant={variant}
        className={classNames}
        size={buttonSize}
        {...restProps}
      >
        {text}
      </MuiButton>
    </ErrorBoundary>
  )
}
